export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Mensagem recebida',
    i18nKey: 'INCOMING',
    attributeI18nKey: 'AUTOMATION.CONDITION.MESSAGES.INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Mensagem enviada',
    i18nKey: 'OUTGOING',
    attributeI18nKey: 'AUTOMATION.CONDITION.MESSAGES.OUTGOING',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'Nenhuma',
    attributeI18nKey: 'CONVERSATION.PRIORITY.OPTIONS.NONE',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Baixa',
    attributeI18nKey: 'CONVERSATION.PRIORITY.OPTIONS.LOW',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Média',
    attributeI18nKey: 'CONVERSATION.PRIORITY.OPTIONS.MEDIUM',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'Alta',
    attributeI18nKey: 'CONVERSATION.PRIORITY.OPTIONS.HIGH',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgente',
    attributeI18nKey: 'CONVERSATION.PRIORITY.OPTIONS.URGENT',
    i18nKey: 'URGENT',
  },
];
